/**
 * Welcome Page Component
 * Shows welcome message for regular users
 */

function WelcomePage() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
            <div className="max-w-2xl w-full">
                <div className="bg-white rounded-2xl shadow-xl p-4 sm:p-8 text-center">
                    <div className="mb-4 sm:mb-6">
                        <div className="text-5xl sm:text-6xl mb-3 sm:mb-4">👮</div>
                        <h1 className="text-2xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
                            أهلاً بك في بوت الشرطة
                        </h1>
                        <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6">
                            مرحباً بك في نظام إدارة البلاغات والتقارير
                        </p>
                    </div>

                    <div className="bg-blue-50 rounded-lg p-4 sm:p-6 mb-4 sm:mb-6">
                        <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">
                            ما يمكنك فعله:
                        </h2>
                        <ul className="text-right space-y-2 text-sm sm:text-base text-gray-700">
                            <li className="flex items-center justify-end space-x-2 space-x-reverse">
                                <span className="text-green-500 text-lg sm:text-xl">✓</span>
                                <span>عرض معلومات حسابك</span>
                            </li>
                            <li className="flex items-center justify-end space-x-2 space-x-reverse">
                                <span className="text-green-500 text-lg sm:text-xl">✓</span>
                                <span>الوصول إلى الميزات المتاحة لك</span>
                            </li>
                        </ul>
                    </div>

                    <div className="text-xs sm:text-sm text-gray-500">
                        <p>للمزيد من الصلاحيات، يرجى التواصل مع المدير</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WelcomePage;
